import { ReactNode } from 'react';
import { useAuth } from './AuthContext';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isChecking, hasAccess, login } = useAuth();

  if (isChecking) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2em', marginBottom: '16px' }}>⏳</div>
          <p style={{ color: 'var(--muted)' }}>Проверка авторизации...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated === false) {
    login();
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--muted)' }}>Перенаправление на страницу входа...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated === true && !hasAccess) {
    window.location.href = '/access-denied';
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--muted)' }}>Перенаправление...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

